<template>
  <div class="page-container-wrapper">
    <loader v-if="dataLoading"/>
    <template v-else>
      <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.Settings.settings') }}</h2>
        <b-button v-if="isSuperUser" variant="info" class="mr-2 ml-auto" @click="$router.push('/')">{{ $t('message.return') }}</b-button>
      </div>

      <div class="page-container" id="page-container">
        <div class="padding">
          <template>
            <b-card>
              <b-row class="my-1">
                <b-col sm="3"><label class="col-form-label">{{ $t("message.Settings.officeEmail") }} <var class="text-danger">*</var></label></b-col>
                <b-col sm="9">
                  <b-form-input :class="errors.first('settings.officeEmail')?'is-invalid':''"  v-validate="'required|email'" data-vv-name="settings.officeEmail" v-model="settings.officeEmail" type="text"></b-form-input>
                  <div class="invalid-feedback">
                    {{ $t("message.incorrectValue") }}
                  </div>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="3">
                  <b-form-checkbox
                      id="checkbox-1"
                      v-model="settings.officeEmailOverride"
                      name="officeEmailOverride"
                      value="1"
                      unchecked-value="0"
                    >
                      {{ $t("message.Settings.officeEmailOverride") }}
                    </b-form-checkbox>
                </b-col>
              </b-row>
            </b-card>
          </template>

          <div class="row">
            <div class="col-12">
              <b-button variant="primary" class="float-right mr-2" @click="update">{{ $t("message.update") }}</b-button>

              <b-button variant="danger" class="float-right mr-2" @click="$router.push('/' )">{{ $t("message.cancel") }}</b-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { SETTINGS_REQUEST, SETTINGS_UPDATE } from '@/store/actions/settings';

export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if ( !vm.isSuperUser ) {
        return next('/');
      }
    })
  },

  name: 'settings',
  components: {},
  props: [],
  data () {
    return {
      settings : {
        officeEmail: '',
        officeEmailOverride: '0'
      }
    }
  },
  computed: {
    ...mapState({
      dataLoading: state => state.settings.status === 'loading',
    }),
  },
  mounted () {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch(SETTINGS_REQUEST)
        .then((response) => {
          this.settings = JSON.parse(JSON.stringify(response));
        }).catch((error) => {
          this.handleUnauth(error.response.status);
          this.handleForbidden(error.response.status);
        });
    },

    update() {
      this.$validator.validate().then(result => {
        if (!result) {
          this.$swal({
            title: 'Error!',
            text: this.$t("message.fillRequiredFields"),
            type: 'error',
            confirmButtonText: 'OK'
          });
          this.showValidateErrors = true;
        } else {
          this.$store.dispatch(SETTINGS_UPDATE, this.settings).then((response) => {
            return this.$swal({
              title: this.$t("message.success"),
              html: this.$t("message.Settings.successfullyUpdated"),
              type: 'success',
              showCancelButton: true,
            });
          }).catch((error) => {
            this.handleUnauth(error.response.status);
            this.handleForbidden(error.response.status);
            this.handleUnprocessable(error.response);
          });
        }
      });
    },
  }
}
</script>

<style  scoped lang="scss">
.settings {

}
</style>

